import { render, staticRenderFns } from "./PrincipalsCompanyManagement.vue?vue&type=template&id=7ec2b9c2&"
import script from "./PrincipalsCompanyManagement.vue?vue&type=script&lang=ts&"
export * from "./PrincipalsCompanyManagement.vue?vue&type=script&lang=ts&"
import style0 from "./PrincipalsCompanyManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports